import { Loadable } from '../Loadable';

export const AsyncSend = Loadable(() => import('./Send'));
export const AsyncConfirmation = Loadable(() => import('./Confirmation'));
